module.exports = __webpack_public_path__ + "img/11.732d8667.png";